import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { createSlice } from '@reduxjs/toolkit';
import { Environment, UserActions } from '@chegg/commerce-utils';
export var initialState = {
  authorization: {
    accessToken: '',
    apiKey: '',
    idToken: '',
    csrfToken: '',
    cheggBaseUrl: ''
  },
  ui: {
    layout: '',
    showSubmitButton: false,
    displayServerErrors: true,
    displayLoadingIndicator: true,
    paymentMethodsRenderFailed: false
  },
  country: '',
  withCoupon: false,
  couponCode: undefined,
  isCouponVerified: false,
  coupon: {
    addCouponStatus: '',
    removeCouponStatus: '',
    totalWithCurrencyFormat: ''
  },
  content: {
    couponContent: undefined,
    orderSummaryContent: undefined
  },
  displayOrderSummary: false,
  rioNamespace: undefined,
  fireRioPurchaseEvent: false,
  uvn: '',
  environment: Environment.DEVELOPMENT,
  userAction: UserActions.JOIN,
  useForter: true,
  recurlyCart: null,
  isRecurly: false
};
var configSlice = createSlice({
  name: 'config',
  initialState: initialState,
  reducers: {
    saveConfigs: function saveConfigs(state, _ref) {
      var payload = _ref.payload;
      return _objectSpread(_objectSpread({}, state), payload);
    },
    saveUiConfigs: function saveUiConfigs(state, _ref2) {
      var payload = _ref2.payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        ui: _objectSpread(_objectSpread({}, state.ui), payload)
      });
    },
    saveContentConfigs: function saveContentConfigs(state, _ref3) {
      var payload = _ref3.payload;
      return _objectSpread(_objectSpread({}, state), {}, {
        content: _objectSpread(_objectSpread({}, state.content), payload)
      });
    }
  }
});
export default configSlice.reducer;
var _configSlice$actions = configSlice.actions,
  saveConfigs = _configSlice$actions.saveConfigs,
  saveUiConfigs = _configSlice$actions.saveUiConfigs,
  saveContentConfigs = _configSlice$actions.saveContentConfigs;
export { saveConfigs, saveUiConfigs, saveContentConfigs };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/redux/config/config.slice.js
// module id = 159
// module chunks = 11